import React from "react";
import { useTranslation } from "react-i18next";
import { useState, useEffect } from "react";
import { Select, MenuItem, Autocomplete, TextField } from "@mui/material";
import CategoryIcon from '@mui/icons-material/Category';
import SwapVertIcon from '@mui/icons-material/SwapVert';




export default function AdsFilter({ title = "Filters", adsList, categories, pays, setFilteredList }) {
    const { t } = useTranslation()
    const [isFiltered, setisFiltered] = useState(false)

    const [search, setSearch] = useState("");
    const [priceChanged, setPriceChanged] = useState(false);
    const [categorie, setCategorie] = useState("all");
    const [country, setCountry] = useState("all");



    useEffect(() => {
        if (categorie != "all" || country != "all" || search || priceChanged) {
            applyFilter()
        } else {
            setFilteredList(adsList)
            setisFiltered(false)
        }
    }, [search, priceChanged, categorie, country])


    const applyFilter = () => {
        setisFiltered(true)


        let result = adsList;



        result = filterSearch(result)
        result = filterCategories(result);
        result = filterPays(result);


        setFilteredList(result)
    }


    const clearFilter = () => {
        setSearch("")
        setPriceChanged(false);
        setCategorie("all");
        setCountry("all")



        setisFiltered(false)
    };




    const filterSearch = (array) => {
        if (search) {
            return array.filter((ad) => {
                return (
                    ad.titre
                        .toLowerCase()
                        .includes(search.toLowerCase()) ||
                    ad.description
                        .toLowerCase()
                        .includes(search.toLowerCase())
                );
            })
        } else {
            return array;
        }
    };







    const filterPays = (array) => {
        if (country != "all") {
            let newArray = [];
            array.forEach((item) => {

                if (item.user.pays == country) {
                    newArray.push(item);
                }
            });
            return newArray;
        } else {
            return array;
        }
    };









    const filterCategories = (array) => {
        if (categorie != "all") {
            let newArray = [];
            array.forEach((item) => {
                if (item.categorie == categorie) {
                    newArray.push(item);
                }
            });
            return newArray;
        } else {

            return array;
        }
    };








    return (
        <div className="col-md-3">
            <div className="d-flex align-items-center justify-content-center">

                <div className="filtre-marketplace">
                    <div className="filter-header">{title}</div>

                    <div className="marketplace-search-position has-search">
                        <i className="fa fa-search form-control-feedback"></i>
                        <input
                            type="text"
                            className="form-control input-search-marketplace"
                            placeholder={t("catalog3.1")}
                            value={search}
                            onChange={(e) => {
                                setSearch(e.target.value);
                            }}
                        />
                    </div>

                    <div className="filter-header-1">
                        <div style={{ marginTop: 3 }}>{t("Filtres.1")}</div>
                        {isFiltered && (
                            <>
                                <span onClick={clearFilter} className="remove-all-filter"><i className="fas fa-times"></i> &nbsp; {t("resetFilter")}</span>
                            </>
                        )}
                    </div>


                    <>
                        <hr />
                        <div className="filter-content">

                            <div className="categories">
                                <h5 className="filter-section-title" style={{ fontSize: 15 }}>
                                    {t("catalog4.1")}
                                </h5>

                                <Select IconComponent={CategoryIcon} value={categorie} onChange={(e) => { setCategorie(e.target.value) }} fullWidth >
                                    <MenuItem value={"all"}>
                                        {t("all")}
                                    </MenuItem>
                                    {categories.map((val, index) => (
                                        <MenuItem key={index} value={val}>
                                            {t("ads.categories." + val)}
                                        </MenuItem>
                                    ))}
                                </Select>



                            </div>
                            <hr />






                            <div className="categories">
                                <h5 className="filter-section-title">
                                    {t("ads.country")}
                                </h5>

                                <Autocomplete
                                    fullWidth
                                    disablePortal
                                    options={[{ label: t("all"), value: "all" }, ...(pays.map((val) => ({
                                        label: val.name,
                                        value: val.name
                                    })))]}
                                    value={country}
                                    onChange={(event, newValue) => {
                                        setCountry(newValue?.value);
                                    }}
                                    renderInput={(params) => (
                                        <TextField {...params} variant="outlined" />
                                    )}
                                    disableClearable={true}
                                />


                            </div>
                            <hr />



                        </div>
                    </>

                </div>
            </div>
        </div>

    )
}











export function AdsOrder({ items, setOrderedItems }) {
    const { t } = useTranslation()
    const [order, setOrder] = useState(0)


    useEffect(() => {
        onChangeOrder(order)
    }, [items])



    const onChangeOrder = (value) => {
        let orderedItems = []


        if ([0, 1].includes(value)) {
            // view order
            orderedItems = [...items].sort((a, b) => a.vu - b.vu)
        } else if ([2, 3].includes(value)) {
            // date order
            orderedItems = [...items].sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime())
        }


        // reverse if not ascending order
        if ([1, 3].includes(value)) {
            orderedItems.reverse()
        }

        setOrder(value)
        setOrderedItems(orderedItems)
    }

    return (
        <div className="col-md-12">
            <div className="section-title seemore endsection">
                <div className="plus">
                    <div >
                        <span className="text-input">{t('catalog1.1')}</span>
                    </div>
                    <div>
                        <Select IconComponent={SwapVertIcon} value={order} onChange={(e) => { onChangeOrder(e.target.value) }} fullWidth >
                            <MenuItem value={0}>
                                {t("ascendingView")}
                            </MenuItem>
                            <MenuItem value={1}>
                                {t("descendingView")}
                            </MenuItem>
                            <MenuItem value={2}>
                                {t("newestToOldest")}
                            </MenuItem>
                            <MenuItem value={3}>
                                {t("oldestToNewest")}
                            </MenuItem>
                        </Select>

                    </div>
                </div>
            </div>
        </div>
    )
}